// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__3eYN_","image":"classes_image__2w1e4","text-container":"classes_text-container__eh9X6","text":"classes_text__3KmdI"};